import moment from 'moment'

const DateFunctions = {
  convertDateFromDBFormat: (myDate: string, hideTime?: boolean) => {
    if (!hideTime) {
      return new Date(myDate).toLocaleString()
    } else {
      return new Date(myDate).toDateString()
    }
  },
  convertDateToHtmlInput: (myDate: string) => {
    return moment(myDate).format('YYYY-MM-DDTHH:mm')
  },
}

export default DateFunctions
